import { Component, Input } from '@angular/core';
import { Floor, BuildingSummary } from '@miq/domain/pv';
import { PVColumn } from '../shared/column.model';

@Component({
  selector: 'pv-cell-render',
  template: `<ng-container> {{ floorData | dataColumnFormatter: column }}</ng-container>`,
  standalone: false,
})
export class CellRenderComponent {
  @Input() floor: Floor;
  @Input() column: PVColumn;
  @Input() buildingInfo: BuildingSummary;

  get floorData() {
    return {
      ...this.floor,
      spaces: this.#filterFloorData(this.floor),
      buildingInfo: this.buildingInfo ?? {},
    };
  }

  #filterFloorData(floor: Floor) {
    return (floor?.spaces ?? []).filter(space => space.lease == null || !!space.lease.active_f);
  }
}
